<template>
  <div>
    <v-container v-if="rooms">
      <v-col v-if="rooms.length">
        <v-row align="center">
          <v-btn
            small
            text
            @click="togglePanels(rooms.map((item, itemIndex) => itemIndex))"
          >
            Развернуть все
          </v-btn>
          <v-divider vertical/>
          <v-btn
            small
            text
            @click="togglePanels"
          >
            Свернуть все
          </v-btn>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-row no-gutters align="center" justify="end">
        <v-btn
          @click="$emit('create')"
        >
          <v-icon class="pr-1"> mdi-plus </v-icon>
          <span>Создать</span>
        </v-btn>
      </v-row>
      <v-row>
        <v-expansion-panels
          multiple
          class="list-group"
          :value="expansionPanels"
        >
          <draggable
            :value="rooms"
            handle=".handle"
            class="row no-gutters"
            @start="togglePanels"
            @input="$emit('list-sort', $event)"
          >
            <!-- <transition-group class="row no-gutters"> -->
            <v-expansion-panel
              class="mb-5 list-group-item"
              v-for="(item, itemIndex) in rooms"
              :key="itemIndex"
            >
              <v-expansion-panel-header>
                <v-row align="center">
                  <!--                  <v-btn-->
                  <!--                    class="handle mr-2"-->
                  <!--                    icon-->
                  <!--                    @click.stop.prevent="() => {}"-->
                  <!--                  >-->
                  <!--                    <v-icon> mdi-cursor-move  </v-icon>-->
                  <!--                  </v-btn>-->
                  <span
                    :class="[
                      errorMessages.$invalid && errorMessages.$dirty ? 'error--text' : ''
                    ]"
                  >
                    № {{ item.number || itemIndex + 1 }}
                    {{ getRoomTypeTitle(item) }}
                  </span>
                </v-row>
                <template #actions>
                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                  >
                    <template #activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="() => {}"
                      >
                        <v-icon> mdi-dots-vertical </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        dense
                        v-for="(option, optionIndex) in $options.itemOptions"
                        :key="optionIndex"
                        :style="{ [option.borderDirection]: option.borderStyle }"
                        @click="optionHandler(option, itemIndex, item)"
                      >
                        {{ option.title }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <InputTitleSlug
                  title-label="Номер"
                  :is-slug-enabled="false"
                  :is-loading="loading"
                  :title="item.number"
                  :title-error="getFieldErrorMessage(itemIndex, 'number')"
                  @change:title="item.number = $event"
                />
                <v-row no-gutters>
                  <v-col cols="12">
                    <span>Тип комнаты</span>
                    <v-select
                      :disabled="loading"
                      :loading="loading"
                      outlined
                      item-value="id"
                      item-text="title"
                      :items="roomTypes"
                      v-model="item.roomTypeId"
                      :error-messages="getFieldErrorMessage(itemIndex, 'roomTypeId')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Этаж</span>
                    <v-text-field
                      v-model.number="item.floor"
                      outlined
                      :disabled="loading"
                      :loading="loading"
                      :error-messages="getFieldErrorMessage(itemIndex, 'floor')"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- </transition-group> -->
          </draggable>
        </v-expansion-panels>
      </v-row>
      <ConfirmationDialog ref="confirm" confirmText="ОК" />
    </v-container>
  </div>
</template>
<script>

import draggable from 'vuedraggable'
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog'
import Option from '@/utils/options/Option'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
const itemOptions = [
  // new Option('Дублировать', 'duplicate'),
  new Option('Удалить', 'delete', 'borderTop', true)
]
export default {
  name: 'FormHotelRooms',
  itemOptions,
  components: {
    InputTitleSlug,
    draggable,
    ConfirmationDialog
  },
  props: {
    rooms: {
      type: Array,
      required: true,
      default: () => []
    },
    roomTypes: {
      type: Array,
      required: true,
      default: () => []
    },
    errorMessages: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expansionPanels: []
    }
  },
  methods: {
    getFieldErrorMessage (index, fieldName, msg = 'Обязательное поле') {
      if (this.errorMessages[index] === undefined) return ''
      const v = this.errorMessages[index][fieldName]
      return v.$invalid && v.$dirty ? [msg] : []
    },
    getRoomTypeTitle (item) {
      const roomType = this.roomTypes.find(roomType => item.roomTypeId === roomType.id)
      return roomType ? `(${roomType.title})` : ''
    },
    togglePanels (list = []) {
      this.expansionPanels = list
    },
    async optionHandler (option, itemIndex, item) {
      const { isConfirm } = option
      if (isConfirm && this.$refs.confirm) await this.$refs.confirm.open()
      this.$emit('option', {
        option,
        itemIndex,
        item
      })
    }
  }
}
</script>
